<div class="app-content content">
  <div class="content-wrapper">
    <div class="content-body">
      <section id="drag-area">
        <div class="row">

          <p>SXDYX</p>
        </div>
      </section>
    </div>
  </div>
</div>
